// 'use client';

// React Imports
import { AnchorHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react';

import { NavLink } from 'react-router-dom';
// Type Imports
import type { ChildrenType } from '../types';

type RouterLinkProps = DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> &
  Partial<ChildrenType> & {
    className?: string;
  };

export const RouterLink = forwardRef((props: RouterLinkProps, ref: any) => {
  // Props
  const { href, className, ...other } = props;

  return (
    <NavLink ref={ref} to={href || ''} className={className} {...other}>
      {props.children}
    </NavLink>
  );
});
